<template>
  <IconText />
</template>
<script setup lang="ts">
import IconText from "@/components/icons/offerTemplate/IconText.vue";
</script>
